// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__394Np","footer":"ModalCreateQualiphyProcedure_footer__3Q24Q","additionData":"ModalCreateQualiphyProcedure_additionData__1MU1t"};